export default "__VITE_ASSET__BIDGhxAh__"